module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }